angular.module('inspinia').directive('materialIcon', () => {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      width: '@',
      height: '@',
    },
    templateUrl: `/manage/src/view/directive/material_icon.html?${new Date().getTime()}`,
    link($scope) {
      $scope.width = $scope.width ?? 24;
      $scope.height = $scope.height ?? 24;
    },
  };
});
